export default __webpack_public_path__ + "media/images/social/linked_in-b43027f9d596129e8e28219d873c9681.png";